import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewEncapsulation,
  Injector,
  ViewChild,
  ElementRef,
  NgZone,
} from "@angular/core";
import { BaseComponent } from "../../base.component";
import { ApiService } from "../../api.service";
import { ColorPickerService } from "../../components/color-picker/color-picker.service";
import { SwatchColorChangedEvent } from "../../events/swatch.color.changed.event";
import { SwatchModel } from "../../models/swatch.model";
import { SwatchChangedEvent } from "../../events/swatch.changed.event";

import { ConfirmationDialogService } from "../../confirmation-dialog/confirmation-dialog.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Location } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import * as cloneDeep from "lodash/cloneDeep";

import * as _ from "underscore";
import { SessionStorageService } from "src/app/session-storge.service";
declare var jQuery: any;
interface SwatchColor {
  hex: string;
  hashHex: string;
  zcc: string;
  empty: boolean;
  refname: string;
  refnumber: string;
}
@Component({
  selector: "file-exchange",
  templateUrl: "./file-exchange.page.html",
  styleUrls: ["./file-exchange.page.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class FileExchange extends BaseComponent implements OnInit {
  exportFormats: any[];
  showBackButton: boolean = false;
  originalSwatches: any = [];
  paletteOptions: any[];
  paletteCheckOptions: any[];
  showWorkSpace = false;
  fileExchange = {
    fileFormat: "PNG",
    swatchFileName: "",
    techPack: "",
    notes: "",
    userName: "",
    company: "",
    date: "",
  };
  @ViewChild("swatchFile") private swatchFile: ElementRef;
  gmPalleteModel = null;
  sub = null;
  constructor(
    private router: Router,
    private location: Location,
    private spinner: NgxSpinnerService,
    public confirmationDialogService: ConfirmationDialogService,
    public injector: Injector,
    public apiService: ApiService,
    public _zone: NgZone,
    public ref: ChangeDetectorRef,
    private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService
  ) {
    super(injector);
    this.sub = this.route.queryParams.subscribe((params) => {
      //console.log(params.savePalleteBuilder);
      if (
        params.savePalleteBuilder != undefined &&
        parseInt(params.savePalleteBuilder) == 1
      ) {
        this.gmPalleteModel = cloneDeep(this.gm.palettesModel);
        this.gm.palettesModel = this.gm.palettesBuilderModel;
      }
    });
  }
  // goBack(){
  // 	this.location.back()
  // }
  ngOnDestroy() {
    if (this.gmPalleteModel != null) {
      this.gm.palettesModel = cloneDeep(this.gmPalleteModel);
    }
    this.sub.unsubscribe();
  }
  ngOnInit() {
    let swatches = [];
    for (
      var i = 0;
      i < this.gm.palettesModel.selectedPalette.swatches.length;
      i++
    ) {
      var swatch = this.gm.palettesModel.selectedPalette.swatches[i];
      if (swatch.empty != true) {
        swatches.push(swatch);
        this.originalSwatches = JSON.parse(JSON.stringify(swatches));
      }
    }
    this.exportFormats = [
      {
        formatID: "PNG",
        formatText: "PNG",
      },
      {
        formatID: "JPG",
        formatText: "JPG",
      },
      {
        formatID: "ASE",
        formatText: "ASE",
      },
      {
        formatID: "ACO",
        formatText: "ACO",
      },
      {
        formatID: "CSV",
        formatText: "CSV",
      },
      {
        formatID: "JSON",
        formatText: "JSON",
      },
    ];
    this.paletteOptions = [
      {
        formatID: "sortByHue",
        formatText: "HUE",
      },
      {
        formatID: "sortBySaturation",
        formatText: "SATURATION",
      },
      {
        formatID: "sortByLightness",
        formatText: "LIGHTNESS",
      },
      {
        formatID: "original",
        formatText: "ORIGINAL",
      },
    ];

    this.paletteCheckOptions = [
      {
        formatID: "indentifyMissingTags",
        formatText: "MISSING TAGS",
        checked: this.gm.palettesModel.selectedPalette.shouldShowMissingTags,
      },
      // {
      // 	'formatID': 'removeDuplicates',
      // 	'formatText': 'Remove Duplicates',
      // 	'checked': false
      // },
    ];

    //this.colorBox.palette = this.gm.palettesModel.selectedPalette
  }
  public filesToUpload;
  public uploadformdata;
  public importFileName = "";
  public addedFileName = "";
  fileChangeEvent(fileInput) {
    if (fileInput.target.files.length == 0) {
      return;
    }
    var file = fileInput.target.files[0];
    var str = file.name;
    this.addedFileName = str;
    var ase = str.indexOf(".ase");
    var aco = str.indexOf(".aco");
    if (ase > -1 || aco > -1) {
      this.filesToUpload = <Array<File>>fileInput.target.files;
      const formData: any = new FormData();
      const files: Array<File> = this.filesToUpload;

      for (let i = 0; i < files.length; i++) {
        formData.append("uploads[]", files[i], files[i]["name"]);
      }
      this.uploadformdata = formData;
    } else {
      if (file.type != "image/jpeg" && file.type != "image/png") {
        this.addedFileName = "";
        alert("Please select PNG or JPG file");
        return;
      }
      this.filesToUpload = <Array<File>>fileInput.target.files;
      const formData: any = new FormData();
      const files: Array<File> = this.filesToUpload;

      for (let i = 0; i < files.length; i++) {
        formData.append("uploads[]", files[i], files[i]["name"]);
      }
      this.uploadformdata = formData;
    }
    if (this.fileExchange.swatchFileName == "")
      this.fileExchange.swatchFileName = this.addedFileName;
    this.importFileData();
    this.swatchFile.nativeElement.value = "";
  }
  importFileData() {
    if (!this.uploadformdata) {
      this.addedFileName = "";
      alert("Select a PNG or JPEG file.");
      return;
    }
    var emptycolorbox = true;
    for (
      var sw = 0;
      sw < this.gm.palettesModel.selectedPalette.swatches.length;
      sw++
    ) {
      var color = this.gm.palettesModel.selectedPalette.swatches[sw];
      if (color.empty == false) {
        emptycolorbox = false;
      }
    }
    this.spinner.show();
    this.apiService.uploadFile(this.uploadformdata).subscribe(
      (data: any) => {
        data = this.apiService.decryptData(data);
        this.spinner.hide();
        if (!data) {
          this.addedFileName = "";
          alert("No data found");
          return;
        }
        if (emptycolorbox) {
          this.replaceSwatches(data);
        } else {
          this.confirmationDialogService
            .fileConfirm(
              "SWATCH FILE LOAD OPTIONS",
              "We've noted a swatch file currently in use. Do you wish to CANCEL this process, MERGE the new file with the existing swatch file, or REPLACE the existing swatch file with the file being loaded?"
            )
            .then((confirmed) => {
              if (confirmed == 1) {
                data.swatches = data.swatches.reverse();
                for (
                  var j = 0;
                  j < this.gm.palettesModel.selectedPalette.swatches.length;
                  j++
                ) {
                  var swatch =
                    this.gm.palettesModel.selectedPalette.swatches[j];
                  if (swatch.empty == true && data.swatches.length > 0) {
                    var respdata = data.swatches.pop();
                    swatch.empty = false;
                    swatch.rgb = respdata.hex;
                    swatch.rgbfull =
                      respdata.red + "," + respdata.green + "," + respdata.blue;
                    swatch.zcc = respdata.zcc;
                    swatch.refname = respdata.referenceName;
                    swatch.refnumber = respdata.referenceNumber;
                  }
                }
                this.gm.palettesModel.writeDefaultFile();
              } else if (confirmed == 2) {
                this.replaceSwatches(data);
              }
            })
            .catch(() => jQuery("#removeDuplicates").prop("checked", false));
        }
      },
      (error) => {
        this.spinner.hide();
        // this.swatchFIleTag.nativeElement.value = "";
        //alert(error.error.message);
        alert(error.error.message);
      }
    );
  }

  replaceSwatches(data) {
    this.importFileName = this.addedFileName;
    for (var i = 0; i < 64; i++) {
      this.gm.palettesModel.selectedPalette.swatches[i].empty = true;
    }
    this.gm.palettesModel.writeDefaultFile();
    for (var i = 0; i < data.swatches.length; i++) {
      var color = data.swatches[i];
      this.gm.palettesModel.selectedPalette.swatches[i].empty = false;
      this.gm.palettesModel.selectedPalette.swatches[i].rgb = color.hex;
      this.gm.palettesModel.selectedPalette.swatches[i].rgbfull =
        color.red + "," + color.green + "," + color.blue;
      this.gm.palettesModel.selectedPalette.swatches[i].zcc = color.zcc;
      this.gm.palettesModel.selectedPalette.swatches[i].refname =
        color.referenceName;
      this.gm.palettesModel.selectedPalette.swatches[i].refnumber =
        color.referenceNumber;
      if (this.gm.palettesModel.selectedPalette.shouldShowMissingTags == true) {
        if (
          this.gm.palettesModel.selectedPalette.swatches[i].refnumber == "" ||
          this.gm.palettesModel.selectedPalette.swatches[i].refname == ""
        ) {
          this.gm.palettesModel.selectedPalette.swatches[i].missingRefTag =
            true;
        } else {
          this.gm.palettesModel.selectedPalette.swatches[i].missingRefTag =
            false;
        }
      } else {
        this.gm.palettesModel.selectedPalette.swatches[i].missingRefTag = false;
      }
      // this.gm.palettesModel.selectedPalette.swatches[i].hslFull = this.zccHsl;
      // this.gm.palettesModel.selectedPalette.swatches[i].hue = this.zccHsl.h;
      // this.gm.palettesModel.selectedPalette.swatches[i].saturation = this.zccHsl.s;
      // this.gm.palettesModel.selectedPalette.swatches[i].lightness = this.zccHsl.l;
    }
    this.gm.palettesModel.writeDefaultFile();
  }

  selectFileFormat(format: any) {
    this.fileExchange.fileFormat = format;
  }
  contrastingFontColor(swatch): string {
    return ColorPickerService.isDarkColor(swatch.rgb)
      ? "rgb(255, 255, 255)"
      : "rgb(0, 0, 0)";
  }

  handleDuplicate(event: any, selectType: any) {
    if (selectType == "removeDuplicates") {
      let b = this.gm.palettesModel.selectedPalette.swatches;
      let uniqueArray: any = [];
      let self = this;

      let isDuplicateExist = false;
      let propertyName = "zcc";
      self._zone.run(() => {
        let testObject = {};
        b.map(function (item: any, index: any) {
          var itemPropertyName = item[propertyName];
          if (itemPropertyName in testObject) {
            if (item.empty == false) {
              isDuplicateExist = true;
            }
          } else {
            let newSwatch = new SwatchModel();
            newSwatch.copy(item);
            testObject[itemPropertyName] = item;
            if (item.empty == false) {
              uniqueArray.push(newSwatch);
            }
          }
        });
        if (isDuplicateExist == true) {
          this.confirmationDialogService
            .confirm(
              "Duplicate Swatch",
              "Duplicate Swatches will be permanently removed."
            )
            .then((confirmed) => {
              if (confirmed) {
                self.loadFileColors(uniqueArray);
              }
              jQuery("#removeDuplicates").prop("checked", false);
            })
            .catch(() => jQuery("#removeDuplicates").prop("checked", false));
        } else {
          this.confirmationDialogService
            .alert("Duplicate Swatch", "No duplicate swatches found.")
            .then((confirmed) => {
              if (confirmed) {
              }
              jQuery("#removeDuplicates").prop("checked", false);
            })
            .catch(() => jQuery("#removeDuplicates").prop("checked", false));
        }
      });
    } else {
      this.fillMissingTags(event);
    }
  }
  fillMissingTags(event: any) {
    if (event.target.checked) {
      this.gm.palettesModel.selectedPalette.shouldShowMissingTags = true;
      this.gm.palettesModel.selectedPalette.swatches.map(function (swatch) {
        if (swatch.refnumber == "" || swatch.refname == "") {
          swatch.missingRefTag = true;
        } else {
          swatch.missingRefTag = false;
        }
      });
    } else {
      this.gm.palettesModel.selectedPalette.shouldShowMissingTags = false;
      this.gm.palettesModel.selectedPalette.swatches.map(function (swatch) {
        swatch.missingRefTag = false;
      });
    }
    this.gm.palettesModel.writeDefaultFile();
  }

  sortPaletteSwatchesBy(value: any) {
    let swatches = [];

    for (
      var i = 0;
      i < this.gm.palettesModel.selectedPalette.swatches.length;
      i++
    ) {
      var swatch = this.gm.palettesModel.selectedPalette.swatches[i];
      if (swatch.empty != true) {
        swatches.push(swatch);
      }
    }
    let sortedobj: any;
    switch (value) {
      case "sortByZCC":
        sortedobj = _.sortBy(swatches, "zcc");
        break;
      case "sortByHue":
        sortedobj = _.sortBy(swatches, "hue");
        break;
      case "sortBySaturation":
        sortedobj = _.sortBy(swatches, "saturation");
        break;
      case "original":
        sortedobj = this.originalSwatches;
        break;
      default:
      //console.log('No format found');
    }
    var sortobj = JSON.parse(JSON.stringify(sortedobj));
    this.loadFileColors(sortobj);
  }
  private importedData: any;
  private paletteColors: SwatchColor[] = [];

  loadFileColors(colorData: any) {
    var self = this;
    let swatches = this.gm.palettesModel.selectedPalette.swatches;
    for (let s = 0; s < swatches.length; s++) {
      swatches[s].empty = true;
      swatches[s].refname = "";
      swatches[s].refnumber = "";
      swatches[s].zcc = "";
      swatches[s].contrastingFontColor = "white";
    }
    self._zone.run(() => {
      self.importedData = colorData;
      self.paletteColors = colorData.map((elem: any) => {
        return {
          hashHex: elem.rgb,
          hex: elem.rgbNoHash,
          refname: elem.refname,
          refnumber: elem.refnumber,
          zcc: elem.zcc,
          empty: false,
        };
      });
    });
    for (var i = 0; i < self.paletteColors.length; i++) {
      let swatchColor = self.paletteColors[i];
      let value = swatchColor.hashHex;

      let o = new SwatchColorChangedEvent({
        oldSwatch: new SwatchModel(
          JSON.parse(JSON.stringify(this.gm.palettesModel.selectedSwatch))
        ),
      });
      let target = this.gm.palettesModel.selectedPalette.swatches[i];
      if (swatchColor.empty) {
        target.empty = true;
      } else {
        target.empty = false;
      }
      let c = this.gm.colorUtility.generateZCCColors(
        value,
        swatchColor.zcc,
        target
      );

      // makes sure the new swatch is not empty now, in case it was empty before applying swatch
      o.newSwatch = new SwatchModel(JSON.parse(JSON.stringify(target)));
      this.gm.palettesModel.swatchColorChanged.emit(o);

      self.gm.palettesModel.selectedPalette.swatches[i].refname =
        swatchColor.refname;
      self.gm.palettesModel.selectedPalette.swatches[i].refnumber =
        swatchColor.refnumber;
      if (
        swatchColor.refnumber ==
        self.gm.palettesModel.selectedPalette.swatches[i].zcc
      ) {
        self.gm.palettesModel.selectedPalette.swatches[i].defaultZcc = true;
      } else {
        self.gm.palettesModel.selectedPalette.swatches[i].defaultZcc = false;
      }
      if (swatchColor.refnumber == "" || swatchColor.refname == "") {
        self.gm.palettesModel.selectedPalette.swatches[i].missingRefTag = true;
      } else {
        self.gm.palettesModel.selectedPalette.swatches[i].missingRefTag = false;
      }
    }
    this.gm.palettesModel.selectedPalette.deselectAllSwatches();
    this.gm.palettesModel.selectedPalette.swatches[0].selected = true;
    var o = new SwatchChangedEvent({
      oldSwatchId: this.gm.palettesModel.selectedSwatch.id,
      oldPaletteId: this.gm.palettesModel.selectedPalette.id,
      newSwatch: this.gm.palettesModel.selectedPalette.swatches[0],
      newPalette: this.gm.palettesModel.selectedPalette,
    });
    this.gm.palettesModel.selectedSwatch =
      this.gm.palettesModel.selectedPalette.swatches[0];
    this.gm.palettesModel.swatchChanged.emit(o);
    this.gm.palettesModel.writeDefaultFile();
  }

  exportFile() {
    if (this.fileExchange.fileFormat == "") {
      alert("Select a File Format to export.");
      return;
    }

    if (this.fileExchange.swatchFileName == "") {
      alert("Select a File Name to export.");
      return;
    }
    let userDetails: any = this.sessionStorageService.getItem("USER_DETAILS");
    this.fileExchange.userName = userDetails.ContactName;
    this.fileExchange.company = userDetails.CompanyName;

    var event = new Date();
    var options: any = { year: "numeric", month: "short", day: "numeric" };
    let date = event.toLocaleDateString("en-US", options);
    let time = new Date();
    var outputdate =
      date +
      "    " +
      time.getHours() +
      ":" +
      time.getMinutes() +
      ":" +
      time.getSeconds() +
      " " +
      new Date()
        .toTimeString()
        .match(new RegExp("[A-Z](?!.*[(])", "g"))
        .join("");
    this.fileExchange.date = outputdate;
    let swatch = this.gm.palettesModel.selectedPalette.swatches;
    var swatches: any = [];
    var paletteInfo = {
      swatches,
    };
    var k = 0;
    var sp = this.gm.palettesModel.selectedPalette;
    for (var i = 0; i < swatch.length; i++) {
      if (swatch[i].empty == false) {
        var rgbArray = swatch[i].rgbfull.split(",");
        paletteInfo.swatches[k] = {
          zcc: swatch[i].zcc,
          hex: swatch[i].rgb,
          red: rgbArray[0],
          green: rgbArray[1],
          blue: rgbArray[2],
          empty: swatch[i].empty,
          referenceName: swatch[i].refname.toUpperCase(),
          referenceNumber: swatch[i].refnumber.toUpperCase(),
          showRefNumber: swatch[i].defaultZcc,
        };
        k++;
      }
    }
    this.spinner.show();
    this.apiService.downloadFile(this.fileExchange, paletteInfo).subscribe(
      (res) => {
        res = this.apiService.decryptData(res);
        this.spinner.hide();
        const element = document.createElement("a");
        element.href = URL.createObjectURL(res.image);
        element.download =
          this.fileExchange.swatchFileName +
          "." +
          this.fileExchange.fileFormat.toLowerCase();
        document.body.appendChild(element);
        element.click();
      },
      (error) => {
        this.spinner.hide();
        alert(error.error.message);
      }
    );
  }

  undoDelete() {
    var pallette = this.gm.palettesModel.selectedPalette;
    if (this.gm.deletedAllStack.length > 0) {
      //fill the stacks on clear all
      while (this.gm.deletedAllStack.length > 0) {
        let lastDeleted = this.gm.deletedAllStack.pop();
        this.gm.palettesModel.selectedPalette.swatches[lastDeleted.index] =
          lastDeleted.data;
        this.gm.palettesModel.updatePalette(
          this.gm.palettesModel.selectedPalette.swatches[lastDeleted.index]
        );
        this.gm.palettesModel.selectedPalette.swatches[lastDeleted.index];
        var o = new SwatchChangedEvent({
          oldSwatchId: this.gm.palettesModel.selectedSwatch.id,
          oldPaletteId: this.gm.palettesModel.selectedPalette.id,
          newSwatch: lastDeleted.data,
          newPalette: pallette,
        });
        this.gm.palettesModel.selectedPalette = pallette;
        this.gm.palettesModel.data.activePaletteId = pallette.id;
      }
      this.gm.palettesModel.writeDefaultFile();
      this.gm.palettesModel.selectedPalette.deselectAllSwatches();
      this.gm.palettesModel.swatchChanged.emit(o);
      this.gm.deletedAllStack = [];
      return;
    }
    let lastDeleted = this.gm.deletedStack.pop();
    if (lastDeleted) {
      this.gm.palettesModel.selectedPalette.swatches[lastDeleted.index] =
        lastDeleted.data;
      this.gm.palettesModel.updatePalette(this.gm.palettesModel.selectedSwatch);
      this.gm.palettesModel.writeDefaultFile();
      this.gm.palettesModel.selectedPalette.deselectAllSwatches();
      this.gm.palettesModel.selectedPalette.swatches[
        lastDeleted.index
      ].selected = true;
      var o = new SwatchChangedEvent({
        oldSwatchId: this.gm.palettesModel.selectedSwatch.id,
        oldPaletteId: this.gm.palettesModel.selectedPalette.id,
        newSwatch: lastDeleted.data,
        newPalette: pallette,
      });
      this.gm.palettesModel.selectedSwatch = lastDeleted.data;
      this.gm.palettesModel.selectedPalette = pallette;
      this.gm.palettesModel.data.activePaletteId = pallette.id;

      this.gm.palettesModel.swatchChanged.emit(o);
    }
  }

  removeAllPallets() {
    this.gm.deletedAllStack = [];
    for (
      let i = 0;
      i < this.gm.palettesModel.selectedPalette.swatches.length;
      i++
    ) {
      let swatch = this.gm.palettesModel.selectedPalette.swatches[i];
      if (swatch.empty == false) {
        let deletedSwatch = Object.assign({}, swatch);
        let deletedArr = { index: i, data: deletedSwatch };
        this.gm.deletedAllStack.push(deletedArr);
      }
    }
    let palette = this.gm.palettesModel.selectedPalette;
    this.gm.palettesModel.removePalette(palette);
    this.gm.palettesModel.writeDefaultFile();
    this.gm.deletedStack = [];
  }

  deleteSelectedPalette() {
    if (this.gm.palettesModel.selectedSwatch.empty == false) {
      let deletedSwatch = Object.assign(
        {},
        this.gm.palettesModel.selectedSwatch
      );
      let index = this.gm.palettesModel.selectedPalette.swatches.findIndex(
        (x) => x.id == this.gm.palettesModel.selectedSwatch.id
      );
      let deletedArr = { index: index, data: deletedSwatch };
      this.gm.deletedStack.push(deletedArr);
      this.gm.palettesModel.selectedSwatch.empty = true;
      this.gm.palettesModel.selectedSwatch.refname = "";
      this.gm.palettesModel.selectedSwatch.refnumber = "";
      this.gm.palettesModel.selectedSwatch.contrastingFontColor = "white";
      this.gm.palettesModel.updatePalette(this.gm.palettesModel.selectedSwatch);
      this.gm.palettesModel.writeDefaultFile();
    }
  }

  showWorkspace(text: any) {
    jQuery("#page-title").html(text);
    this.createScrollScript();
    this.showWorkSpace = !this.showWorkSpace;
    this.ref.markForCheck();
  }

  createScrollScript() {
    var s = document.createElement("script");
    s.setAttribute("src", "../../../assets/scrollbar.js");
    s.onload = () => {
      jQuery("body").find("#zcc-color-examples").customScrollbar();
    };
    document.body.appendChild(s);
  }
}
